var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('h3',[_vm._v("Elimina tu cuenta")])]),_c('b-row',[_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.deleteAccount}},[_vm._v(" Eliminar ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }